import React, { createContext, useContext, useReducer } from "react";

const CartContext = createContext();

const initialState = {
  items: [],
};

function sortIds(arr = []) {
  return arr.map((x) => x.id).sort();
}

function reducer(state, action) {
  switch (action.type) {
    case "ADD_ITEM": {
      const p = action.payload;
      //console.log(action);

      const existingIndex = state.items.findIndex((it) => {
        return (
          it.dishId === p.dishId &&
          JSON.stringify(sortIds(it.extras)) ===
            JSON.stringify(sortIds(p.extras)) &&
          JSON.stringify(sortIds(it.acompanamientos)) ===
            JSON.stringify(sortIds(p.acompanamientos)) &&
          (it.note || "") === (p.note || "")
        );
      });

      // 🔒 Si ya existe, SIEMPRE suma 1
      if (existingIndex > -1) {
        const items = [...state.items];
        items[existingIndex] = {
          ...items[existingIndex],
          qty: items[existingIndex].qty + 1,
        };
        return { ...state, items };
      }

      // 🔒 Si no existe, siempre entra con qty = 1
      return {
        ...state,
        items: [
          ...state.items,
          {
            dishId: p.dishId,
            name: p.name,
            namecor: p.namecor,
            price: p.price,
            extras: p.extras || [],
            acompanamientos: p.acompanamientos || [],
            note: p.note || "",
            qty: 1,
          },
        ],
      };
    }

    case "REMOVE_ITEM":
      return {
        ...state,
        items: state.items.filter((_, i) => i !== action.index),
      };

    case "UPDATE_QTY": {
      const items = [...state.items];
      items[action.index] = {
        ...items[action.index],
        qty: action.qty,
      };
      return { ...state, items };
    }

    case "DECREMENT_ITEM": {
      const items = [...state.items];
      const it = items[action.index];

      if (it.qty > 1) {
        items[action.index] = {
          ...it,
          qty: it.qty - 1,
        };
      } else {
        items.splice(action.index, 1); // elimina si era 1
      }

      return { ...state, items };
    }

    case "CLEAR_CART":
      return initialState;

    default:
      return state;
  }
}

export function CartProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <CartContext.Provider value={{ state, dispatch }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
